import { render, staticRenderFns } from "./ProductCategoryAddView.vue?vue&type=template&id=54123c49&scoped=true&"
import script from "./ProductCategoryAddView.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54123c49",
  null
  
)

export default component.exports